const my_profile = {
  viewMyClubSeacretProfile: "查看我的 ClubSecret 个人资料", // translated
  viewMoreDetails: "查看更多详情", // translated
  verifiedEmail: "已验证的电子邮件", // translated
  unverifiedEmail: "未经验证的电子邮件", // translated
  pointsIn: "点入", // translated
  balance: "平衡", // translated
  pointsOut: "指出", // translated
  pointsHistoryTable: "积分历史表", // translated
  topUp: "充值", // translated
  createdFrom: "创建自", // translated
  createdTo: "创建至", // translated
  selectStatus: "选择状态...", // translated
  searchByTitle: "按标题搜索...", // translated
  pushNotifications: "推送通知",
  pushNotificationsDescription: "接收浏览器通知以获取重要更新和事件",
  pushNotificationsNotSupported: "此浏览器不支持推送通知",
  pushNotificationsDeniedMessage: "通知权限被拒绝。请在浏览器设置中启用通知以接收推送通知。",
  pushNotificationsEnabled: "推送通知已成功启用",
  pushNotificationsDisabled: "推送通知已成功禁用",
  userInformationMissing: "缺少用户信息",
  failedToUpdatePushNotifications: "无法更新推送通知设置",
  notificationPermissionDenied: "通知权限被拒绝。请在浏览器设置中启用它。",
  notificationPermissionRequired: "需要通知权限才能启用推送通知",
  notSupported: "不支持",
  permissionDenied: "权限被拒绝",
  permissionNotRequested: "未请求权限",
  enabled: "已启用",
  disabled: "已禁用",
};

export default my_profile;
